<template lang="html">
	<header class="row">
		<div class="logo">
			<img src="~@/assets/img/logo-patrim.svg" alt="">
		</div>
  	<nav class="row">
  		<router-link :to="{name: item.uri}" class="menu-item" v-for="item in menu" v-bind:key="item.key" v-html="item.name" v-if="item.visibleForAdmin || isSuperAdmin"></router-link>
  	</nav>
		<div class="manage row">
			<router-link :to="{name: 'Profile'}" class="ctn-profil">
				<img :src="picture" alt="">
			</router-link>
		</div>
	</header>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
	name: 'my-header',
	data () {
		return {
      show: this.isSuperAdmin,
			menu: [
				{
					key: 0,
					name: '<span class="icon-nav-admin-conseiller"></span> Conseillers',
          uri: 'Conseillers',
          visibleForAdmin: true
				},
				{
					key: 1,
					name: '<span class="icon-nav-admin-clients"></span> Clients',
					uri: 'Clients',
          visibleForAdmin: true
				},
				{
					key: 2,
					name: '<span class="icon-nav-admin-cabinets"></span> Cabinets',
					uri: 'Cabinets',
          visibleForAdmin: false
				},
				// {
				// 	key: 3,
				// 	name: '<span class="icon-nav-admin-stat"></span> Statistiques',
				// 	uri: 'Statistiques'
				// },
				// {
				// 	key: 4,
				// 	name: '<span class="icon-nav-admin-encaissement"></span> Encaissements',
				// 	uri: 'Encaissements'
				// },
				// {
				// 	key: 5,
				// 	name: '<span class="icon-operations-folder"></span> Contrats et supports',
				// 	uri: 'ContractsSupports'
				// }
			],
			notifs: [
				{
					key: 0
				}
			]
		}
	},
	methods: {
        setActive () {
            this.$emit('notif-open')
        }
	},
  computed: {
      ...mapState({
        picture: state => state.users.picture
      }),
      ...mapGetters({
        count: 'count',
        isSuperAdmin: 'isSuperAdmin'
      })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// header.vue?057df9a4